<template>
  <div id="lm-wait">
    <LmSelect v-model="actionSelected" :options="options" />
    <div v-if="actionSelected === 'Enviar email'">
      <LmSuperPowerSelect
        :data="lmSuperPowerSelects.emailTemaplates.selectOptions"
        :tbColumns="lmSuperPowerSelects.emailTemaplates.tbColumns"
        label="Templates emails"
        title="Templates emails"
        :model="emailTemplateSelected"
        @values="updateEmailTemplates"
      />
      <LmButton
        :disabled="!emailTemplateSelected"
        buttonClass="btn-primary"
        @click.native="getHtmlEmailTemplate(emailTemplateSelected)"
        value="Preview"
        type="button"
        class="btn"
        lmButtonWrapperClass="col p-0"
      />
    </div>
    <LmSuperPowerSelect
      v-if="actionSelected === 'Enviar push notification'"
      :data="lmSuperPowerSelects.pushNotificationTemaplates.selectOptions"
      :tbColumns="lmSuperPowerSelects.pushNotificationTemaplates.tbColumns"
      label="Push notification templates"
      :model="pushNotificationTemaplates"
      @values="updatePushNotificationTemaplates"
    />
    <LmTemplatePreviewModal ref="lmTemplatePreviewModal" />
  </div>
</template>

<script>
import LmSelect from '@/components/form/elements/LmSelect'
import LmSuperPowerSelect from '@/components/form/elements/LmSuperPowerSelect'
import LmButton from '@/components/form/elements/LmButton'
import LmTemplatePreviewModal from '@/components/modals/LmTemplatePreviewModal.vue'
import lmSuperPowerSelectHelper from '@/mixins/LmSuperPowerSelectHelper.js'
export default {
  mixins: [lmSuperPowerSelectHelper],
  components: {
    LmSelect,
    LmSuperPowerSelect,
    LmButton,
    LmTemplatePreviewModal
  },
  data () {
    return {
      selectedEmailTemplate: '',
      actionSelected: '',
      emailTemplateSelected: '',
      pushNotificationTemaplates: '',
      lmSuperPowerSelects: {
        emailTemaplates: {
          selectOptions: [],
          tbColumns: [{ title: 'Template', data: 'name' }]
        },
        pushNotificationTemaplates: {
          selectOptions: [
            { name: 'Push Bienvenido' },
            { name: 'Push Descuento' },
            { name: 'Push Cumple' }
          ],
          tbColumns: [{ title: 'Push', data: 'name' }]
        }
      }
    }
  },
  methods: {
    getHtmlEmailTemplate (idEmailTemplate) {
      this.$refs.lmTemplatePreviewModal.openEmailPreviewModal(idEmailTemplate)
    },
    updateEmailTemplates (values) {
      this.emailTemplateSelected = values.length ? values[0].id : ''
    },
    updatePushNotificationTemaplates () {
      console.log('updatePushNotificationTemaplates')
    }
  },
  props: {
    options: {
      type: Object,
      default: () => ({
        disabledOption: 'Seleccione una acción',
        content: []
      })
    }
  },
  watch: {
    actionSelected () {
      this.emailTemplateSelected = ''
    }
  },
  async mounted () {
    try {
      const allLmSPSelectOptions = await this.getAllLmSuperPowerSelectOptions(
        [
          { name: 'emailTemaplates',
            obj: {
              path: 'templates/',
              total: null
            }
          }
        ]
      )
      allLmSPSelectOptions.forEach(async oneLmSPSelectOptions => {
        let specificLmSPSelectOptions = await oneLmSPSelectOptions
        if (specificLmSPSelectOptions.name === 'emailTemaplates') {
          specificLmSPSelectOptions.data = specificLmSPSelectOptions.data.map(
            element => (
              {
                name: element.nombre,
                id: element.hidden_id.toString()
              }
            )
          )
        }
        this.lmSuperPowerSelects[specificLmSPSelectOptions.name].selectOptions = specificLmSPSelectOptions.data
      })
    } catch (error) {
      console.log('error', error)
    }
  }
}
</script>
